import { SvgCommonProperties } from '../../common/svg.interfaces';

export default function SearchSvg(props: SvgCommonProperties){
  return <svg
    height={props.height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-6 h-6"
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="16" y1="16" x2="21" y2="21" />
  </svg>
} 